// extracted by mini-css-extract-plugin
module.exports = {"container":"editor_container__1ca_f","body":"editor_body__1rMcG","status":"editor_status__7RtXv"};